<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button link="/procurement-management/invoices"></back-button>
          Update Invoice
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`/procurement-management/invoices`"
              >Invoices</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Tab -->
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="invoice-tab"
                  data-bs-toggle="tab"
                  href="#invoice"
                  role="tab"
                  aria-controls="invoice"
                  aria-selected="true"
                  >Purchase order</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="invoiceDetial-tab"
                  data-bs-toggle="tab"
                  href="#invoiceDetial"
                  role="tab"
                  aria-controls="invoiceDetial"
                  aria-selected="false"
                  >Purchase order Details</a
                >
              </li>
            </ul>
            <div class="tab-content border border-top-0 p-3" id="myTabContent">
              <!-- For Purchase order Sectiion -->
              <div
                class="tab-pane fade show active"
                id="invoice"
                role="tabpanel"
                aria-labelledby="invoice-tab"
              >
                <h4>Purchase order</h4>
                <hr />
                <invoice-form :form="form"></invoice-form>
              </div>
              <!-- For Requsition Details -->
              <div
                class="tab-pane fade"
                id="invoiceDetial"
                role="tabpanel"
                aria-labelledby="invoiceDetial-tab"
              >
                <h4>Purchase order Details</h4>
                <hr />
                <invoice-detail-form :form="form"></invoice-detail-form>
              </div>
            </div>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="update"
                text="Update"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";
import InvoiceForm from "../invoices/invoice-form.vue";
import InvoiceDetailForm from "../invoices/invoice-detail-form.vue";
export default {
  components: { InvoiceForm, InvoiceDetailForm },
  name: "RequsitionUpdate",
  data() {
    return {
      form: {
        quotation_id: "",
        receipt_port_id: "",
        receiving_person_id: "",
        delivered_in: "",
        purchase_order_details: [
          {
            category_id: "",
          },
        ],
      },

      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let form = await axios.get(`/invoices/${this.$route.params.invoiceId}`);
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        await axios.post(`/invoices`, this.form);
        this.isLoading = false;
        this.$router.push("/procurement-management/invoices");
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      this.imagepath = this.$refs.imagepath
        ? this.$refs.imagepath.files[0]
        : "";
      this.attachment = this.$refs.attachment
        ? this.$refs.attachment.files[0]
        : "";
      let formData = new FormData();
      formData.append("id", this.crew.id);
      formData.append("imagepath", this.imagepath);
      formData.append("attachment", this.attachment);
      await this.$axios
        .post("upload_attachments", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((data) => {
          console.log(data);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    async handleDocumentUpload() {
      this.doc_attachment = this.$refs.doc_attachment
        ? this.$refs.doc_attachment.files[0]
        : "";
      let formData = new FormData();
      formData.append("id", this.crew.id);
      formData.append("doc_attachment", this.doc_attachment);
      await this.$axios
        .post("upload_attachments", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((data) => {
          // this.filePath = data.data
          console.log(data);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
  },
};
</script>
